import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'components';
import styles from './ProductCard.module.scss';

export default function ProductCard({ product, onOpen }) {
  const navigate = useNavigate();

  const handleOpen = () => {
    if (typeof onOpen === 'function') return onOpen(product.id);
    navigate('/product', { state: { id: product.id } });
  };

  // format price: show integer part without decimals and append 'сом'
  const formatPrice = (p) => {
    if (p == null || p === '') return '';
    // try to convert to number, tolerate comma decimals
    let n = Number(p);
    if (Number.isNaN(n)) {
      const s = String(p).replace(/\s+/g, '').replace(',', '.');
      n = parseFloat(s);
    }
    if (Number.isNaN(n)) return String(p);
    const intPart = Math.trunc(n);
    return `${intPart.toLocaleString('ru-RU')} сом`;
  };

  return (
    <div className={styles.card}>
      <div className={styles.imageWrap}>
        {product.main_image ? <img src={product.main_image} alt={product.name} className={styles.image} /> : <div className={styles.noImage}>{product.name}</div>}
      </div>
      <div className={styles.content_prod}>
      <div className={styles.title}>{product.name}</div>
      <div className={styles.price}>{formatPrice(product.price)}</div>
      <div className={styles.actions}>
        <Button onClick={handleOpen} className={`${styles.btnFull} btn btn_modal_close`}>Подробнее</Button>
      </div>
      </div>
    </div>
  );
}
